import { HIGState } from "../../config/HIGState"

export function renderTestID(testID?: string, suffix?: string) {
  return HIGState.testIDSupportEnabled
    ? (testID && suffix ? `${testID}#${suffix}` : testID)
    : undefined
}
